import Services from './services';
const apiUrl = process && process.env && process.env.NODE_ENV === 'development' ? '' : '/api';
const services = new Services(apiUrl);
export default services;
